import { useEffect, useState, useRef } from 'react'
import { useLockFn } from 'ahooks'
import { Table, Input, Checkbox, message } from 'antd'
import { ColumnsType } from "antd/es/table";
import { YHDrawer } from '@/components/YhDrawer'
import { useApprovalModel } from "../approvalModel";
import { UserFields, ApprovalFlowNodeFields } from '../ApprovalTypes';
import debounce from 'lodash/debounce';
import '../approval.less'

import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";

interface PropsType {
    onSubmitOk: (data: ApprovalFlowNodeFields) => void;
}
export const AddNodeDrawer = (props: PropsType) => {

    const { onSubmitOk } = props;
    const {
        addNodeDrawer, setAddNodeDrawer,
        dataSource, loadUserData, pgCfg, initPgCfg,
    } = useApprovalModel()

    const formRef = useRef<IYhFormRef>();
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [selectedData, setSelectedData] = useState<UserFields>();
    const [searchKey, setSearchKey] = useState<string>();
    const [duty, setDuty] = useState<string>();

    useEffect(() => {
        if (addNodeDrawer.visible) {
            if (addNodeDrawer.node?.nodeTitle != null) {
                formRef.current?.setFieldsValue({ ...addNodeDrawer.node });
                setSelectedRowKeys([addNodeDrawer.node.approvalCode]);
                setSelectedData({ code: addNodeDrawer.node.approvalCode, name: addNodeDrawer.node.approvalName })
                setDuty(addNodeDrawer.node.approvalDuty);
            }
            else {
                formRef.current?.setFieldsValue({ 'nodeType': 0 })
            }
            loadUserData().then();
        }
        else {
            setSelectedRowKeys([]);
            setSelectedData({})
            setDuty("");
        }
    }, [addNodeDrawer.visible])

    const onOk = useLockFn(async () => {
        await formRef.current?.validateFields().then(async (res) => {
            if (selectedRowKeys == null || selectedRowKeys.length == 0) {
                message.error("请选择审批角色");
                return
            }
            onSubmitOk({
                ...res,
                "id": addNodeDrawer.node?.id,
                "approvalCode": selectedData?.code,
                "approvalName": selectedData?.name,
                "approvalDuty": duty,
            });
            setAddNodeDrawer({ ...addNodeDrawer, visible: false })
            setSelectedRowKeys([]);
            setSelectedData({});
        })
    })

    const onCancel = () => {
        setAddNodeDrawer({ ...addNodeDrawer, visible: false })
    }

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '角色名称',
            dataIndex: 'name',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '角色编号',
            dataIndex: 'code',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '使用人数',
            dataIndex: 'userNum',
            align: "center",
            ellipsis: true,
        }
    ];

    const handleSearch = debounce((data: string) => {
        loadUserData(initPgCfg, { "name": data })
        setSearchKey(data);
    }, 1000)

    const onRow = (record: UserFields) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.code) {
            setSelectedRowKeys([]);
            setSelectedData({});
            setDuty("");
        } else {
            setSelectedRowKeys([record.code]);
            setSelectedData(record);
            setDuty(record.job);
        }
    };

    const formConfig: IYhForm = {
        labelCol: { span: 4 },
        disabled: false,
        formClassName: "addDrawer-form",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "节点名称",
                fieldName: "nodeTitle",
                span: 24,
                rules: [{ required: true, message: "请填写节点名称" }]
            },
            {
                type: FormItemTypeEnum.Radio,
                fieldLabel: "节点类型",
                fieldName: "nodeType",
                span: 24,
                hidden: true,
                radioDs: [{ label: "审批", value: 0 }, { label: "抄送", value: 1 }],
            },
        ]
    };

    return (
        <div className='addDrawer-class'>
            <YHDrawer
                {...{
                    title: '审批节点配置',
                    width: 540,
                    visible: addNodeDrawer.visible,
                    closable: true,
                    onOk,
                    onCancel,
                    showFooter: true,
                }}
            >
                <YhForm formRef={formRef} {...formConfig} />
                <div style={{ fontWeight: 'bold', fontSize: 20, marginBottom: 5 }}>审批角色设置:</div>
                <div className="addDrawer-user">
                    <div className="addDrawer-select">
                        <div className="addDrawer-select-header">
                            选择角色
                        </div>
                        <div className="addDrawer-select-search">
                            <Input placeholder="请输入角色名称检索" onChange={e => handleSearch(e.target.value)} />
                        </div>
                        <div className="addDrawer-select-content">
                            <Table
                                rowClassName="addDrawer-table-row"
                                rowKey={record => record.code}
                                rowSelection={{
                                    type: "radio",
                                    selectedRowKeys: selectedRowKeys, //记录选中
                                    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                                        onRow(selectedRows[0]);
                                    }
                                }}
                                columns={columns}
                                dataSource={dataSource}
                                pagination={{
                                    ...pgCfg,
                                    simple: true,
                                    showTotal: (total: number) => `共${total}条`,
                                    position: ["bottomCenter"],
                                    onChange: (pageNum, pageSize) => {
                                        searchKey ? loadUserData({ pageNum, pageSize }, { "name": searchKey }) : loadUserData({ pageNum, pageSize })
                                    }
                                }}
                                onRow={record => ({
                                    onClick: () => onRow(record)
                                })}
                                scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
                            />
                        </div>
                    </div>
                    <div className="addDrawer-selected">
                        <div className="addDrawer-selected-header">
                            已选角色
                        </div>
                        {selectedData && selectedData.code &&
                            <div className="addDrawer-selected-content">
                                <div className="addDrawer-selected-content-left"><Checkbox defaultChecked={true} disabled>{selectedData?.name}</Checkbox></div>
                                {/* <div className="addDrawer-selected-content-right">职位：<Input style={{ width: 200 }} value={duty} onChange={(e) => setDuty(e.target.value)} /></div> */}
                            </div>
                        }
                    </div>
                </div>
            </YHDrawer>
        </div>
    )
}
